import { Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import { useNotify } from '../../../../hooks/useNotify';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';
import { parseClient, saveClient } from '../../clientedit/clientMapper';
import PriceItemTable from '../../../../components/PriceItemTable';

const ClientPriceItemEditForm = ({ clientId }) => {
    const { notifySuccess, notifyError } = useNotify();
    const [client, loading, error, setClient] = useSwaggerClient(
        'clients',
        'getClient',
        {
            clientId
        },
        [],
        res => parseClient(res.client)
    );

    const formSaveDisabled = client?.client_price_items
        ? client?.client_price_items.filter(e => !e.name).length > 0
        : false;

    if (loading) {
        return <CircularProgress />;
    }
    return (
        <Grid container item xs={12}>
            {!error ? (
                <Grid container item xs={12} spacing={2}>
                    <PriceItemTable
                        items={client?.client_price_items || []}
                        setItems={items => {
                            setClient(c => {
                                return {
                                    ...c,
                                    client_price_items: items.map(item => ({
                                        ...item,
                                        net_usd: parseFloat(item.net_usd),
                                        net_percentage: parseFloat(item.net_percentage)
                                    }))
                                };
                            });
                        }}
                    />
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={formSaveDisabled}
                            onClick={() => {
                                saveClient(clientId, client)
                                    .then(() => notifySuccess('Successfully updated price items'))
                                    .catch(err => notifyError(err.response.body.message));
                            }}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <h4>Could not load price items</h4>
            )}
        </Grid>
    );
};

export default ClientPriceItemEditForm;
